<calendar-form-input #calendarEditor [config]="config" [formControl]="calendarControl"></calendar-form-input>
